export interface IUserBanStatus {
  Id: string;
  apiKey: string;
  appKey: string;
  banStatus: boolean;
}
